/* liva-cart-ladder.js — the cart drawer's ladder updater (SPEC §39.7, Phase 8b).
   <liva-cart-ladder data-group-ids=",id,id,…"> wraps the shared ladder
   (snippets/bundle-ladder) in .cart-drawer__top — the pinned slot Impact's
   CartDrawer never re-renders while the cart has items. Liquid renders the
   count at first paint and on every full re-render (0 ↔ n, cart:refresh);
   this element mirrors the same rule on cart:change — packs = quantities of
   the lines whose product_id is in data-group-ids, paid and free alike,
   capped at 4 — and makes the two writes the PDP's _renderLadder makes
   (SPEC §24): data-count on .bundle-ladder, is-reached on points 1..n.
   Nothing else: no figures, no text, no fetch. Browser floor SPEC §20.5
   (ES2015 class, no modules, no class fields). A throwing handler must never
   break the drawer (SPEC §20.2), hence the try/catch. */
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('liva-cart-ladder')) return;
  var FREE_EVERY = 4;

  class LivaCartLadder extends HTMLElement {
    constructor() {
      super();
      this._onCartChange = this._onCartChange.bind(this);
    }
    connectedCallback() {
      document.addEventListener('cart:change', this._onCartChange);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:change', this._onCartChange);
    }
    _groupIds() {
      var ids = {};
      (this.getAttribute('data-group-ids') || '').split(',').forEach(function (s) {
        var n = parseInt(s, 10);
        if (!isNaN(n)) ids[n] = true;
      });
      return ids;
    }
    _onCartChange(event) {
      try {
        var detail = event && event.detail, cart = detail && detail.cart, items = cart && cart.items;
        if (!items || typeof items.length !== 'number') return;
        var ids = this._groupIds(), packs = 0;
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (item && ids[item.product_id]) packs += parseInt(item.quantity, 10) || 0;
        }
        this._render(Math.min(packs, FREE_EVERY));
      } catch (e) { /* never break the drawer */ }
    }
    _render(count) {
      var ladder = this.querySelector('[data-bundle-ladder]');
      if (!ladder) return;
      ladder.setAttribute('data-count', String(count));
      var points = ladder.querySelectorAll('[data-bundle-point]');
      for (var i = 0; i < points.length; i++) {
        points[i].classList.toggle('is-reached', count >= parseInt(points[i].getAttribute('data-bundle-point'), 10));
      }
    }
  }
  window.customElements.define('liva-cart-ladder', LivaCartLadder);
})();
